import type { UserConfidenceRange } from './converters';

export const PIPELINE_SETTINGS_DEFAULTS = {
  max_llm_timeout: 3,
  max_retries_per_llm: 1,
  max_characters_number_per_system_prompt_variable: 100000,
  link_mic_audio: false,
  preemptive_synthesis: true,
  code_box_debug_on: false,
  use_datetime_tool: true,
  trigger_next_agent_response: false,
  strip_tool_call_content: false,
  silence_triggers: [] as { sec: number; msg: string }[],
  max_agent_wait_sec_on_mutual_silence: null,
  background_audio: {
    enabled: false,
  },
  voicemail_detection: {
    enabled: false,
  },
  ppx_model: 'sonar-pro',
  ppx_temperature: 0.2,
  ppx_timeout_sec: 10,
  ppx_search_context_size: 'medium',
  ppx_max_tokens: 200,
  fallback: {
    attempt_timeout: 1.5,
    max_retry: 1,
    retry_interval: 0.1,
  },
  missing_confidence_default: 1.0,
  user_confidence_ranges: null as UserConfidenceRange[] | null,
} as const;
